import { useId } from "react";

import { cn } from "@/lib/utils";

export default function WizardHeroIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[812px] w-[375px]", className)}
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 375 812"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}-a)`}>
        <path d="M0 0h375v812H0z" fill="#000" />
        <path d="M-1002.5 0H5049v737.145h-6051.5z" fill={`url(#${id}-b)`} />
        <g filter={`url(#${id}-c)`}>
          <ellipse
            cx="199.35"
            cy="305.799"
            fill="#31C7ED"
            rx="588.137"
            ry="590.185"
          />
        </g>
        <path
          clipRule="evenodd"
          d="M-1206.47 257.966s67.55 0 193.58-33.602c12.7-3.388 31.804-15.471 55.035-13.266 23.214 2.214 29.239 11.936 29.239 11.936s10.313-5.303 23.214-5.303c12.9 0 33.544 11.052 33.544 11.052 29.104-56.696 63.479-72.549 119.161-62.341 55.682 10.208 62.279 60.127 62.279 60.127s18.261-8.742 31.604-6.747c15.471 2.319 13.122 16.031 13.122 16.031s55.89-.446 88.788 10.833c0 0-1.94-39.412 78.713-23.495 0 0 59.029-100.74 161.67-94.798 98.472 5.696 105.937 94.798 105.937 94.798s44.505-5.591 61.916 0c17.41 5.592-5.804 23.495-5.804 23.495s52.231-8.619 88.363-8.619c36.131 0 39.977 19.899 39.977 19.899s34.821-7.298 45.152-6.633c10.314.665 20.644 6.633 20.644 6.633H-1206.47z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M-333.021 604.833H669.38L269.972 168.8l-48.018 16.918-80.081 72.573-85.396 9.963-389.498 336.579z"
          fill={`url(#${id}-d)`}
        />
        <path
          clipRule="evenodd"
          d="M189.996 545.114l.277-7.33-6.522-31.858-13.848-15.43-4.956-11.222h1.021l5.969 9.91 14.58 14.72 9.911-9.91 2.477-8.307 9.619-9.765.704 1.24-8.309 9.169-2.014 9.264-9.925 12.321 5.158 27.411.859 3.82 7.682-10.41.723-17.765 16.241-9.656 6.291-15.629 14.915-12.085-.271 1.663-12.561 11.267-4.119 11.924 7.323-8.343 15.944-7.323v1.112l-14.832 7.954-9.362 10.957-16.964 9.826v12.884l26.79-21.783 19.559-3.708v1.112l-19.559 5.339-26.141 23.675-9.919 16.222 1.86 44.582h-10.331l1.495-39.623-23.816-24.963-.927-6.052-15.934-8.739v-1.779l18.086 9.488.889 5.781 12.156 12.156 9.781 7.883z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M-37.324 360.842c-3.873 31.334-20.684 68.799-28.606 83.615H52.013l-18.484-27.725c-41.544-22.18-64.545-46.502-70.853-55.89z"
          fill="#DAA1B5"
        />
        <path
          d="M-48.07 428.71c4.824-12.203 10.998-42.926 13.48-56.762l61.375 119.556s-70.615 18.703-68.8 13.861c0-47.807-6.055-76.655-6.055-76.655z"
          fill={`url(#${id}-e)`}
        />
        <path
          d="M94.63 422.306c1.149-4.592 6.199-13.259 17.22-11.193 13.776 2.583 11.623 15.498 0 13.345-9.298-1.722-3.874-5.94 0-7.834m-18.819-6.156h34.518M40.153 371.07c6.573-2.343 34.646-15.401 36.451-17.432v9.785M48.027 368v7.291m9.595-12.035v8.39"
          stroke="#fff"
          strokeWidth="1.307"
        />
        <path
          clipRule="evenodd"
          d="M3.805 444.458c-17.487-19.233-32.389-46.346-41.152-83.435l.023-.181c6.308 9.389 29.31 33.711 70.853 55.891l18.484 27.725H3.805z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M76.587 362.602c-9.934 5.96-23.013 10.52-28.808 12.412l-30.51 63.503h89.27c-13.623-21.57-25.104-59.36-29.952-75.915z"
          fill="#DAA1B5"
        />
        <path d="M67.414 358.795v8.39" stroke="#fff" strokeWidth="1.307" />
        <path
          d="M146.677 577.005c-12.872-14.009-5.401-71.51-5.401-71.51l-71.821-16.511-8.7 88.021h85.922z"
          fill="#4D0D54"
        />
        <path
          d="M88.856 412.861c-6.812-14.475-12.535-36.305-14.545-45.41l-49.313 92.948s79.711 43.823 68.564 34.141c-11.146-9.683-4.706-81.679-4.706-81.679z"
          fill={`url(#${id}-f)`}
        />
        <path
          d="M73.753 411.203l-3.946 37.241h6.815l4.283-38.041a2.809 2.809 0 00-2.791-3.123 4.385 4.385 0 00-4.361 3.923z"
          fill={`url(#${id}-g)`}
        />
        <path
          clipRule="evenodd"
          d="M73.349 448.444l3.538-29.189h3.02l.074-.654h-3.015l1.372-11.312a2.77 2.77 0 00-.225-.009c-.147 0-.292.007-.436.021l-1.37 11.3h-3.339l-.069.654h3.33l-3.539 29.189h.659z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M76.523 362.336c-9.924 5.921-30.414 13.111-36.178 14.993L16.372 438.87h40.866c6.6-19.709 14.462-53.745 19.285-76.534z"
          fill="#fff"
        />
        <path
          d="M119.851 456.275H72.786l17.37 54.779h71.113c-19.239-11.045-35.629-41.122-41.418-54.779z"
          fill="#CE9FB6"
        />
        <path
          d="M-3.411 447.52l-5.652-116.094 8.847-9.584 40.55 2.457V447.52l-34.406 4.424-9.34-4.424z"
          fill={`url(#${id}-h)`}
        />
        <path
          d="M27.477 393.37h-4.935l-1.632-39.983a32.54 32.54 0 013.408-15.88l.546 1.296a33.338 33.338 0 012.613 12.937v41.63z"
          fill={`url(#${id}-i)`}
        />
        <path
          d="M-3.245 305.788l-14.491 27.74 25.876-7.263h43.744l-16.21-20.477-22.771-67.903-16.148 67.903z"
          fill={`url(#${id}-j)`}
        />
        <path
          d="M96.127 506.145c-34.717-32.762-56.64-74.365-63.26-91.072l9.251-14.87s22.766 50.969 73.263 105.942H96.127z"
          fill="#A36281"
        />
        <path
          d="M5.19 322.169l-5.406-.327-8.847 9.584 5.652 116.094 13.757 6.679-5.155-132.03z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M13.005 238.192l-1.67 71.853-5.195 16.781-23.876 6.702 14.491-27.74 16.148-67.903.102.307z"
          fill="#4D0D54"
          fillRule="evenodd"
        />
        <path
          d="M13.002 436.772c-22.004 46.453-43.804 63.567-51.954 66.318 0 0 7.987 59.728 0 86.661h144.847c-9.028-18.074-5.302-86.661-5.302-86.661-37.615-40.128-47.353-63.363-61.92-89.544-7.335 9.535-20.17 19.457-25.671 23.226z"
          fill={`url(#${id}-k)`}
        />
        <circle cx="50.579" cy="488.511" fill="#4D0D54" r="13.138" />
        <path
          d="M39.685 533.118v56.571h24.033v-56.571c0-6.637-5.38-12.016-12.016-12.016-6.637 0-12.017 5.379-12.017 12.016z"
          fill={`url(#${id}-l)`}
        />
        <path
          clipRule="evenodd"
          d="M1.504 589.751v-95.079l-32.227 3.606c-3.428 2.608-6.237 4.139-8.23 4.812 0 0 7.988 59.728 0 86.661H1.505z"
          fill={`url(#${id}-m)`}
          fillRule="evenodd"
        />
        <path
          d="M25.745 528.123l1.367 28.953H16.228l-2.136-30.053a4.952 4.952 0 014.94-5.304 6.721 6.721 0 016.713 6.404z"
          fill={`url(#${id}-n)`}
        />
        <path
          d="M19.66 521.719l2.39 35.227m-7-15.705h11.205"
          stroke="#fff"
          strokeWidth="1.307"
        />
        <path
          d="M77.971 528.123l-1.367 28.953H87.49l2.135-30.054a4.952 4.952 0 00-4.94-5.303 6.72 6.72 0 00-6.713 6.404z"
          fill={`url(#${id}-o)`}
        />
        <path
          d="M84.056 521.719l-2.39 35.227m6.999-15.705H77.461"
          stroke="#fff"
          strokeWidth="1.307"
        />
        <path
          d="M111.878 528.123l-1.366 28.953h10.884l2.136-30.054a4.953 4.953 0 00-4.94-5.303 6.721 6.721 0 00-6.714 6.404z"
          fill="#4D0D54"
        />
        <path
          d="M-7.78 504.312c29.582-25.182 45.535-79.968 49.814-104.213L-7.78 412.936s-22.954 69.664-63.473 94.432l63.473-3.056z"
          fill="#fff"
        />
        <path
          d="M74.878 355.564l1.686 8.557 1.555-8.557-1.555-22.69-1.686 22.69z"
          fill={`url(#${id}-p)`}
        />
        <path
          d="M11.385 232.362l1.685 8.557 1.556-8.557-1.556-22.69-1.685 22.69z"
          fill={`url(#${id}-q)`}
        />
        <path
          d="M24.156 338.006l.854 55.364m-4.115-38.011h6.582m-5.709 21.223h5.716"
          stroke="#fff"
          strokeWidth="0.654"
        />
        <path
          d="M120.809 538.543l-3.062 28.759m10.473-27.97l-3.061 28.758m10.472-27.969l-3.061 28.759m10.471-27.971l-3.061 28.759m9.258-16.57l-1.847 17.359m10.049-24.004l-2.638 24.792m10.05-24.002l-2.639 24.792m10.05-24.004l-2.639 24.792m-51.963-29.194L146 546.646m-8.338 15.792l35.619 3.791"
          stroke="#FFEDED"
          strokeWidth="1.238"
        />
        <path
          clipRule="evenodd"
          d="M254.271 222.944l81.626.234 651.528 1.893 130.605.38 265.75.771 64.2.185 36.17.108 137.72.39 52.3.156c-13.15-2.732-26.12-4.829-38.77-6.41-73.99-9.248-136.7-.741-157.72 2.8-4.9.83-7.55 1.386-7.55 1.386s-2.53-3.093-9.53-6.517c-5.66-2.81-14.32-5.834-26.94-7.581-21.19-2.936-42.85-.048-55.88 2.449-7.55 1.454-12.19 2.781-12.19 2.781s1.84-4.215 2.71-9.278c1.11-6.449.61-14.293-7.32-16.576-14.11-4.068-32.27 0-32.27 0s-24.22-28.79-82.76-33.18c-55.97-4.185-100.87 3.649-104.69 4.351-.17.02-.26.039-.26.039-.26-.224-.52-.458-.79-.683a87.73 87.73 0 00-4.25-3.483c0-.019-.06-.048-.09-.068a115.563 115.563 0 00-12.13-8.146c-25.54-14.946-51.99-31.146-113.38-27.381-83.436 5.113-108.38 45.781-108.38 45.781-95.037-13.971-168.706 11.502-168.706 11.502s-38.335-4.654-74.688 4.663c-19.474 4.986-26.762 13.668-29.328 20.664-.816 2.185-1.166 4.214-1.253 5.902-1.079-1.385-3.294-2.781-7.521-3.776a2.757 2.757 0 00-.234-.058c-12.127-2.742-32.301-1.093-32.301-1.093v-.019c-26.304-44.095-95.369-44.76-115.631-45.134-56.76-1.054-82.868 22.548-122.369 38.363-14.401 5.756-25.392 10.722-31.368 13.522-3.353 1.551-5.131 2.439-5.131 2.439-28.307-8.907-59.179 8.624-59.179 8.624z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.3"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M-125.806 668.103C40.227 712.035-252.27 826.579-437.503 838.054l1678.623 20.513 48.83-282.846H-365.018c-70.805 2.566-356.653 1.739-329.157 22.688 34.369 26.187 469.896 29.929 568.369 69.694z"
          fill={`url(#${id}-r)`}
        />
        <path
          clipRule="evenodd"
          d="M20.382 681.116c45.862 43.868-167.817 125.58-266.686 153.829l63.531 6.061 1426.183 4.332 22.26-128.981C802.44 584.422 367.687 576.172 367.687 576.172l-37.994-.451h-694.711c-14.462.524-37.896.907-65.799 1.362-50.36.822-115.277 1.882-168.279 4.44-18.078 2.83-25.741 5.512-16.231 7.75 11.446 2.693 56.899 5.932 118.283 10.306 165.865 11.818 475.584 41.514 517.426 81.537z"
          fill="#48A3CD"
          fillRule="evenodd"
        />
        <path
          d="M59.573 662.066c-39.133-.524-83.603-2.449-129.018-7.041 0 0 57.042-4.998 57.92-6.735.333-.665.737-1.408 1.196-2.199 2.88-4.849 13.34-11.288 21.73-10.617 12.021.959 18.427 15.873 20.516 18.753l.01-.001c.218.306.328.464.328.464s3.598-11.523 11.147-.527l.084.111s.058-.188.177-.535c1.627-4.889 14.942-42.109 39.917-39.467 11.282 1.18 21.214 14.568 27.869 26.337a151.403 151.403 0 017.73 15.839c.2.489.383.921.514 1.257.275.693.421 1.068.421 1.068s-.067-.304-.137-.8c-.379-2.391-1.007-9.276 4.4-8.789 5.52.504 10.905 7.661 12.44 9.873.271.411.43.643.43.643s.476-.147 1.366-.366c2.962-.749 10.562-2.38 20.567-2.436 12.983-.084 36.148 1.578 36.148 1.578s-21.346 1.735-55.901 2.845c-1.635.056-3.302.096-4.998.149-1.656.049-3.343.091-5.06.136-6.345.17-13.058.304-20.095.416-15.181.228-31.884.285-49.701.044z"
          fill="#fff"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M909.612 556.402c-206.121-13.065-710.942 9.415-819.805 19.33C840.964 598.96 742.28 756.178 615.032 808.116l414.738 49.656c195.66-15.181 415.09-267.444-120.158-301.37z"
          fill="#4E6EC0"
        />
        <ellipse
          cx="343.723"
          cy="705.634"
          fill={`url(#${id}-s)`}
          rx="88.332"
          ry="9.519"
          style={{ mixBlendMode: "multiply" }}
        />
        <path
          d="M289.344 698.196c-2.224 4.181-8.154 11.934-14.086 9.491-4.074-1.677 1.408-6.032 3.666-4.258"
          stroke="#413776"
          strokeLinecap="round"
          strokeWidth="3.225"
        />
        <path
          d="M352.715 639.298c-4.66-1.685-9.625 2.354-11.525 4.585 0 .991 1.405 1.652 2.107 1.859 2.107-2.231 6.939-4.09 6.939-1.859 0 1.784-1.817 4.626-2.726 5.824l2.726 1.735c2.602-.992 8.302-10.037 2.479-12.144z"
          fill="#413776"
        />
        <path
          d="M310.116 589.332c-18.018 5.812-16.59 51.028 14.642 40.53-22.3-5.396 17.713-15.79 10.053-38.04-7.661-22.25-15.977-22.228-22.516-24.649 4.359 2.179 20.343 14.893-2.179 22.159z"
          fill={`url(#${id}-t)`}
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M271.66 639.298c4.66-1.685 9.625 2.354 11.525 4.585 0 .991-1.405 1.652-2.107 1.859-2.107-2.231-6.939-4.09-6.939-1.859 0 1.784 1.817 4.626 2.726 5.824l-2.726 1.735c-2.602-.992-8.302-10.037-2.479-12.144z"
          fill="#413776"
        />
        <path
          d="M330.288 634.06h-37.04l-4.044 5.924c-14.705 5.924-24.683 17.46-24.683 30.72 0 19.306 21.153 34.956 47.247 34.956s47.247-15.65 47.247-34.956c0-13.26-9.979-24.795-24.683-30.72l-4.044-5.924z"
          fill={`url(#${id}-u)`}
        />
        <path
          d="M335.92 698.196c2.224 4.181 8.154 11.934 14.086 9.491 4.074-1.677-1.409-6.032-3.666-4.258"
          stroke="#413776"
          strokeLinecap="round"
          strokeWidth="3.225"
        />
        <path
          d="M282.256 632.828a2.42 2.42 0 012.357-2.966h54.311a2.42 2.42 0 012.356 2.966l-.71 3.058a2.419 2.419 0 01-2.356 1.872h-52.892a2.419 2.419 0 01-2.356-1.872l-.71-3.058z"
          fill="#413776"
        />
        <path
          clipRule="evenodd"
          d="M295.758 703.602c4.999 1.332 10.39 2.058 16.01 2.058 26.094 0 47.247-15.651 47.247-34.956 0-13-9.59-24.342-23.822-30.365 6.187 22.103 2.583 55.861-39.435 63.263z"
          fill="#413776"
          fillRule="evenodd"
        />
        <path
          d="M258.293 540.509c-30.176-10.481-30.044 13.038-26.206 26.108 110.022 11.229 216.38 3.297 255.806-2.072-.847-15.172-13.178-16.473-19.238-15.227 7.837-31.16-16.363-49.929-37.89-16.651-3.442-9.3-13.677-7.788-18.364-5.869-.904-48.191-40.169-44.848-43.8-9.264-12-8.895-21.895-2.235-25.343 2.207-8.584-12.381-25.93-11.595-31.667 4.648-21.158-41.199-49.598-20.132-39.937 4.933-11.729-1.936-13.794 6.651-13.361 11.187z"
          fill="#3FC7C0"
        />
        <path
          d="M338.234 541.656c-1.202-6.741-4.734-19.387-9.254-16.042-4.52 3.345 4.286 12.088 9.254 16.042z"
          fill="#209F99"
        />
        <path
          clipRule="evenodd"
          d="M421.206 570.753c.176-17.341-14.385-25.003-28.242-3.811-2.301-6.995-9.688-5.989-13.094-4.611.25-36.044-28.044-34.02-31.32-7.457-8.462-6.797-15.701-1.937-18.263 1.343-5.94-9.362-18.427-8.984-22.856 3.092-14.444-31.062-35.285-15.655-28.807 3.204-7.681-1.455-9.712 3.773-9.829 7.275 59.753 4.764 115.373 3.461 152.411.965zm-156.143-1.27c-3.274-.888-5.95-1.07-8.123-.716 2.714.251 5.422.49 8.123.716z"
          fill="#209F99"
          fillRule="evenodd"
        />
        <path
          d="M374.989 704.272c-41.851 11.158-64.28 11.158-64.28 11.158h226.279c-10.924-3.745-40.059-7.343-40.059-7.343s.78-4.553-4.357-5.323c-4.431-.663-10.496 2.24-10.496 2.24s-2.19-16.577-20.681-19.967c-18.491-3.39-29.906 1.875-39.571 20.702 0 0-6.855-3.67-11.139-3.67-4.284 0-7.709 1.761-7.709 1.761s-2-3.228-9.709-3.963c-7.715-.733-14.059 3.28-18.278 4.405z"
          fill="#fff"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          clipRule="evenodd"
          d="M97.644 576.205l-28.623.104-228.462.838-45.797.168-93.188.342-22.51.082-12.686.047-48.291.173-18.339.069c4.61-1.21 9.159-2.138 13.596-2.838 25.944-4.096 47.933-.328 55.303 1.24 1.718.367 2.648.613 2.648.613s.889-1.369 3.343-2.886c1.983-1.244 5.019-2.583 9.445-3.356 7.432-1.301 15.027-.022 19.597 1.084 2.647.644 4.273 1.231 4.273 1.231s-.644-1.866-.951-4.108c-.388-2.856-.215-6.329 2.566-7.34 4.947-1.801 11.316 0 11.316 0s8.495-12.748 29.022-14.692c19.627-1.853 35.369 1.616 36.709 1.927a.688.688 0 01.092.017c.092-.099.184-.203.276-.302a32.45 32.45 0 011.492-1.543c0-.008.021-.021.031-.03a41.395 41.395 0 014.252-3.607c8.955-6.618 23.379-11.954 44.908-10.286 29.256 2.264 32.855 18.433 32.855 18.433 33.325-6.186 59.157 5.094 59.157 5.094s13.443-2.061 26.19 2.065c6.829 2.207 9.384 6.052 10.284 9.149.286.968.409 1.867.44 2.614.378-.613 1.155-1.231 2.637-1.672.02-.009.051-.017.082-.026 4.252-1.214 11.326-.484 11.326-.484v-.008c-.04-.186-1.206 3.546 0 .008 0-11.646 21.725-20.139 40.237-20.571 19.904-.466 41.718 10.99 54.219 23.552-2.096-1.24 5.05 2.549 0 0a71.05 71.05 0 011.799 1.08c9.926-3.944 20.752 3.819 20.752 3.819z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.8"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M151.627 742.892c.293-.682 7.103-18.792 10.472-27.762l32.512-45.906 17.412 51.142c1.015 7.549 3.117 23.062 3.41 24.718.365 2.07 13.516 5.114 15.22 5.358 1.705.243-6.819 1.704-9.01 2.313-2.192.609 8.889 3.897 10.472 5.114 1.582 1.218-20.092 8.767-35.921 11.446-15.83 2.679-27.032 1.462-34.095-1.339-7.062-2.801-22.161-4.627-21.187-4.627.779 0 6.251-4.384 8.889-6.576-3.734.366-11.227.877-11.324 0-.122-1.095 10.472-5.479 11.324-6.331.852-.853 1.461-6.697 1.826-7.55z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.181"
        />
        <path
          d="M172.982 617.151c-2.096 4.658-.873 7.505 0 8.346-3.058 0-11.145 1.93-14.806 2.894l-7.451-2.306-2.04 26.523c3.43 2.011 10.538 6.068 11.531 6.21.994.142 7.525-2.432 10.667-3.736 2.042 2.68.319 15.9-.798 22.175-4.839 10.849-14.454 32.993-14.199 34.779.319 2.234 26.802 23.931 27.919 22.974.893-.766 3.475-16.003 10.372-38.335l12.889 34.062c1.85-.092 8.774-10.833 12.005-16.191l-7.409-15.601c.12-5.417-5.123-24.836-7.759-33.869 1.813.767 12.416 5.081 16.717 6.68 9.787-3.68 11.642-20.251 5.044-23.052-1.859-1.569-9.209-7.129-10.255-8.036-1.307-1.133-2.092-.174-4.533-2.092-2.44-1.918-5.579-10.897-5.84-12.117-.209-.976-3.257-2.207-4.755-2.7 2.902-2.814 2.902-4.309-.791-9.497s-4.119-12.809-5.313-14.169c-.955-1.087-2.944-.819-3.819-.549-1.605-1.185-4.327-1.352-5.487-1.288-1.116-.354-3.553-1.152-4.37-1.511-1.021-.449-7.064 1.307-7.519 3.348-.364 1.634-3.192 5.777-4.561 7.644.776 1.242 2.588.065 3.397-.679-.389 3.494.614 8.184 1.164 10.093z"
          fill="#fff"
        />
        <path
          clipRule="evenodd"
          d="M149.055 652.825l.65-13.478 1.02-13.262 7.451 2.306c3.661-.964 11.748-2.894 14.806-2.894-.873-.841-2.096-3.688 0-8.346-.55-1.909-1.553-6.599-1.165-10.093-.808.744-2.62 1.921-3.396.679 1.369-1.867 4.197-6.01 4.561-7.644.455-2.041 6.498-3.797 7.519-3.348.817.359 3.253 1.157 4.37 1.511 1.16-.064 3.882.103 5.486 1.288.876-.27 2.865-.538 3.82.549.446.508.785 1.889 1.226 3.691.741 3.022 1.773 7.228 4.087 10.478.361.507.686.979.977 1.42l-.186.183c.122.04.253.085.393.134 2.466 3.834 2.156 5.288-.393 7.76 1.498.493 4.546 1.724 4.755 2.7.261 1.22 3.4 10.199 5.84 12.117 1.371 1.077 2.219 1.247 2.931 1.389.556.111 1.029.206 1.602.703.485.42 2.319 1.837 4.335 3.393 2.339 1.806 4.922 3.8 5.92 4.643 5.808 2.466 5.065 15.605-1.874 21.224-4.793-1.895-10.684-4.298-11.993-4.852.333 1.14.581 2.32.761 3.522a740.987 740.987 0 01-8.655-3.522c2.636 9.033 7.879 28.452 7.759 33.869l5.289 11.137c-3.502 5.542-8.378 12.686-9.885 12.761l-12.889-34.062c-4.121 13.345-6.702 24.156-8.302 30.859-1.078 4.515-1.71 7.167-2.07 7.475-.946.811-20.076-14.619-26.113-20.725 2.976-7.717 8.916-21.339 12.393-29.133.558-3.137 1.268-8.011 1.583-12.436.092-.138.15-.238.161-.344.012-.104-.022-.214-.113-.369.256-4.133.132-7.759-.834-9.026-3.141 1.304-9.672 3.878-10.666 3.736-.959-.137-7.615-3.922-11.161-5.993z"
          fill={`url(#${id}-v)`}
          fillRule="evenodd"
        />
        <path d="M190.357 631.479l3.924 65.703" stroke="#fff" />
        <path
          clipRule="evenodd"
          d="M228.473 663.002c-8.674-2.107-21.347-7.845-25.958-12.102l1.325 13.751 1.584 1.055c3.58 1.471 11.596 4.712 15.195 6.049 3.867-1.453 6.495-4.919 7.854-8.753zm-60.274 18.51c8.556-9.922 4.725-57.045 4.725-48.262 0 7.062-7.519 21.429-12.724 25.496l-.087.049c.04.011.074.019.103.023.994.142 7.525-2.432 10.667-3.736 2.042 2.68.319 15.9-.798 22.176-.57 1.278-1.207 2.713-1.886 4.254zm-15.652-26.676c3.983-9.856 1.129-23.533.16-28.135l-2.247 2.821-1.775 23.087c1.04.609 2.418 1.407 3.862 2.227z"
          fill="#17677C"
          fillRule="evenodd"
        />
        <path
          d="M235.195 619.38l3.051 10.218v3.973l-7.25 28.195-2.666 31.007v23.732l-7.069 36.837 2.892 1.767 6.843-38.604 1.546-20.842 5.459-10.591c-.086-1.339-.41-4.015-1.025-4.015s-3.213 4.519-4.434 6.778l1.182-9.576v-8.985c1.3-6.226 3.901-19.033 3.901-20.452 0-1.419 3.481-10.758 5.221-15.251v-5.957l2.348-5.401c3.046-2.49 9.204-7.726 9.473-8.741.269-1.015-.501-1.375-.919-1.428l-6.863 3.043c0-.995 7.466-6.35 11.2-8.903.415-1.053 1.187-3.235.957-3.542-.23-.306-8.201 4.149-12.157 6.414a1736.972 1736.972 0 00-5.17-4.595c-.612-.536-1.914 1.628-2.489 2.776l1.915 5.84-1.915 7.849c-.326-.893-1.224-2.833-2.201-3.446-.978-.613-1.627 1.012-1.83 1.9z"
          fill={`url(#${id}-w)`}
        />
        <path
          d="M147.427 621.226l-3.764-3.109c-6.583-.742-10.057 16.205-10.449 23.975-.392 7.771 2.983 15.149 5.023 15.698 1.633.44 3.611-1.125 4.396-1.962l4.794 1.962c1.28-2.145 4.185-7.833 5.566-13.421 1.382-5.589-.575-17.19-1.726-22.292l-3.84-.851z"
          fill="#fff"
        />
        <path
          d="M235.383 648.371c-.893-.772-3.283-.322-4.366 0-.366 1.828 1.032 6.515 1.777 8.631.288.457 1.371 1.33 3.401 1.167 2.539-.203 4.011-9.037 3.402-9.798-.487-.609-3.012-.254-4.214 0z"
          fill="#4D0D54"
        />
        <path
          d="M145.508 638.037c.706-2.895-.647-13.678-1.412-18.707-4.588 0-7.5 16.148-7.589 20.648-.088 4.5.618 14.56 2.471 14.56 1.853 0 5.647-12.884 6.53-16.501z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.181"
        />
        <path
          d="M224.743 645.393c-.574.064-1.514.718-1.913 1.037 1.515 1.993 4.401 7.223 3.827 12.197-.574 4.975-5.129 11.533-7.335 14.191.797.266 2.519.797 3.03.797.51 0 1.807 1.01 2.391 1.515 4.545-.718 7.096-11.64 7.893-17.539.797-5.9-2.551-10.763-3.109-10.683-.558.08-4.066-1.594-4.784-1.515z"
          fill="#fff"
        />
        <path
          d="M136.293 615.052c.479 0 5.249 3.101 7.574 4.651 2.416 1.582 2.158 8.234 1.728 11.362l-7.043-9.9-3.521 1.727c-2.304-.155-7.083-.465-7.774-.465-.864 0-4.252-3.455-4.252-5.049 0-1.595 2.658-.133 3.388 0 .585.106 3.522-.665 4.917-1.063-3.721-.665-3.721-2.126-2.458-2.392 1.262-.266 6.843 1.129 7.441 1.129z"
          fill="#4D0D54"
        />
        <path
          d="M181.272 606.96c-4.664 5.347-7.54 15.389-5.83 17.41.887 1.048 8.51 5.028 14.535 3.731 5.592-1.205 9.664-7.638 9.327-8.161-.56-.871-4.482-11.866-6.373-17.255-1.944-.804-6.996-1.073-11.659 4.275z"
          fill="#4D0D54"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeWidth="0.181"
        />
        <path
          d="M180.572 629.21c-.853-5.212.824-10.603 5.145-14.355 1.375-1.195 2.967-1.362 4.538-.91 6.945 2.002 7.205 11.187 8.627 18.274 3.242 16.161 12.391 16.714 17.583 27.199 6.16 12.438-3.595 19.746 1.659 25.113 5.253 5.368 8.47 1.698 10.247 0-1.536 2.114-7.746 5.671-11.113 3.63-3.367-2.042-4.228-2.8-4.228-15.713 0-12.912-15.992-22.507-17.888-24.284-1.895-1.777-13.504-12.438-14.57-18.954z"
          fill="#fff"
        />
        <g filter={`url(#${id}-x)`}>
          <path
            d="M106.659 625.393c2.843 6.397 12.142 7.108 16.437 6.664 6.071-1.185 18.48-4.798 19.546-9.773 1.333-6.22-4.442-9.774-8.218-11.329-3.776-1.554-1.999-4.886 3.776-7.33 5.775-2.443 8.442-5.389 4.442-12.438s-12.883-11.106-12.661-7.33c.222 3.776-4.664 9.107-8.44 7.33-3.776-1.777-1.333-5.775-1.333-9.107 0-2.666-1.185-4.813-1.777-5.553.222 3.998-13.993 11.994-13.993 18.214 0 6.219 7.107 8.44 7.774 11.328.666 2.887-9.107.222-7.774 3.11 1.332 2.887-1.333 8.218 2.221 16.214z"
            fill={`url(#${id}-y)`}
            shapeRendering="crispEdges"
          />
        </g>
        <g filter={`url(#${id}-z)`}>
          <path
            d="M141.309 610.956c2.665-1.259 7.774-6.62 6.885-13.55 1.037 5.405 1.111 15.682-6.885 13.55z"
            fill="#2AF5C4"
          />
        </g>
        <ellipse
          cx="221.166"
          cy="596.747"
          fill="#4D0D54"
          rx="2.991"
          ry="3.963"
          transform="rotate(-20.248 221.166 596.747)"
        />
        <ellipse
          cx="221.462"
          cy="592.252"
          fill="#4D0D54"
          rx="0.674"
          ry="1.483"
          transform="rotate(-5.25 221.462 592.252)"
        />
        <ellipse
          fill="#4D0D54"
          rx="0.674"
          ry="1.483"
          transform="scale(-1 1) rotate(35.246 -1043.21 -46.403)"
        />
        <path
          d="M234.402 581.165c-8.968 4.707-11.106 11.708-11.027 14.866l.002.022c.013.115.093.212.133.321l.496 1.363c.039.109.097.226.21.249a.298.298 0 00.278-.09c1.691-1.807 4.718-2.424 6.123-2.353.249.012.435-.28.318-.5-1.66-3.129.696-5.155 2.385-5.916a.31.31 0 00.153-.407c-1.171-2.601.033-5.272 1.347-7.01.195-.257-.132-.695-.418-.545zm-33.415 12.327c9.877-2.244 16.049 1.691 18.04 4.144l.013.018c.065.095.066.221.107.329l.508 1.36c.041.108.073.234.002.325a.299.299 0 01-.27.113c-2.459-.277-5.162 1.22-6.185 2.186-.181.171-.511.07-.565-.173-.77-3.458-3.878-3.469-5.656-2.951a.31.31 0 01-.381-.21c-.799-2.738-3.448-3.987-5.576-4.455-.315-.069-.351-.615-.037-.686z"
          fill="#4D0D54"
        />
        <ellipse
          cx="182.555"
          cy="421.244"
          fill="#4D0D54"
          rx="2.991"
          ry="3.963"
          transform="rotate(24.772 182.555 421.244)"
        />
        <ellipse
          cx="185.944"
          cy="418.276"
          fill="#4D0D54"
          rx="0.674"
          ry="1.483"
          transform="rotate(39.77 185.944 418.276)"
        />
        <ellipse
          fill="#4D0D54"
          rx="0.674"
          ry="1.483"
          transform="scale(-1 1) rotate(-9.774 2345.638 1276.23)"
        />
        <path
          d="M202.935 419.593c-9.669-3.017-16.133.419-18.31 2.708a.08.08 0 00-.015.017c-.072.09-.084.215-.133.32l-.614 1.315c-.049.104-.091.228-.027.324a.3.3 0 00.26.134c2.473-.082 5.05 1.623 5.993 2.667.167.185.505.11.578-.128 1.04-3.386 4.139-3.152 5.871-2.495a.31.31 0 00.396-.18c1.012-2.666 3.752-3.703 5.91-4.001.32-.045.399-.585.091-.681zm-32.341-14.924c8.569 5.4 10.149 12.547 9.821 15.689a.185.185 0 01-.004.023c-.022.113-.11.203-.158.308l-.602 1.321c-.047.105-.114.217-.229.231a.3.3 0 01-.27-.111c-1.543-1.935-4.512-2.79-5.918-2.83-.249-.007-.411-.312-.278-.522 1.902-2.989-.287-5.195-1.91-6.087a.31.31 0 01-.121-.418c1.372-2.5.383-5.257-.79-7.094-.174-.271.187-.682.459-.51z"
          fill="#4D0D54"
        />
        <path d="M0 0h375v616H0V0z" fill={`url(#${id}-A)`} opacity="0.5" />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="2023.25"
          x2="2023.25"
          y1="26.885"
          y2="867.486"
        >
          <stop stopColor="#FF9877" />
          <stop offset="1" stopColor="#FFC6B5" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-d`}
          x1="168.179"
          x2="168.179"
          y1="-45.14"
          y2="604.832"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="-2.124"
          x2="-43.617"
          y1="574.116"
          y2="378.958"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="67.739"
          x2="26.966"
          y1="560.985"
          y2="374.637"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-g`}
          x1="75.365"
          x2="75.365"
          y1="407.28"
          y2="448.444"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-h`}
          x1="21.256"
          x2="-35.007"
          y1="517.81"
          y2="337.657"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-i`}
          x1="24.18"
          x2="24.18"
          y1="337.507"
          y2="393.37"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-j`}
          x1="24.997"
          x2="1.931"
          y1="381.949"
          y2="240.352"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-k`}
          x1="49.954"
          x2="12.114"
          y1="678.957"
          y2="416.626"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-l`}
          x1="51.702"
          x2="51.702"
          y1="536.874"
          y2="608.165"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-m`}
          x1="-14.12"
          x2="-51.486"
          y1="637.886"
          y2="503.802"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-n`}
          x1="20.595"
          x2="20.595"
          y1="521.719"
          y2="557.076"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-o`}
          x1="83.121"
          x2="83.121"
          y1="521.719"
          y2="557.076"
        >
          <stop stopColor="#E76823" />
          <stop offset="1" stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-p`}
          x1="76.867"
          x2="53.334"
          y1="379.94"
          y2="359.353"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-q`}
          x1="13.374"
          x2="-10.159"
          y1="256.738"
          y2="236.151"
        >
          <stop stopColor="#DA6689" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-r`}
          x1="296.961"
          x2="296.961"
          y1="575.721"
          y2="858.567"
        >
          <stop stopColor="#FF9860" />
          <stop offset="1" stopColor="#FFE2B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-s`}
          x1="471.563"
          x2="-77.618"
          y1="743.608"
          y2="702.71"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-t`}
          x1="315.032"
          x2="315.032"
          y1="581.184"
          y2="629.862"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-u`}
          x1="311.768"
          x2="311.768"
          y1="634.06"
          y2="705.66"
        >
          <stop stopColor="#7785F1" />
          <stop offset="1" stopColor="#413776" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-v`}
          x1="189.306"
          x2="189.306"
          y1="596.674"
          y2="721.059"
        >
          <stop stopColor="#2891C5" />
          <stop offset="1" stopColor="#166576" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-w`}
          x1="240.172"
          x2="240.172"
          y1="602.627"
          y2="755.109"
        >
          <stop stopColor="#AE6328" />
          <stop offset="1" stopColor="#4D0D54" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-y`}
          x1="124.432"
          x2="124.432"
          y1="598.561"
          y2="655.113"
        >
          <stop stopColor="#2AF5C4" />
          <stop offset="1" stopColor="#2AF5C4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-A`}
          x1="187.5"
          x2="187.5"
          y1="187.22"
          y2="616"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2750.87"
          id={`${id}-c`}
          width="2746.77"
          x="-1174.04"
          y="-1069.63"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_28846"
            stdDeviation="392.625"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="68.816"
          id={`${id}-x`}
          width="53.419"
          x="97.723"
          y="569.937"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.295" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6284_28846"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6284_28846"
            result="shape"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="27.016"
          id={`${id}-z`}
          width="20.555"
          x="134.719"
          y="590.816"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.295" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6284_28846"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6284_28846"
            result="shape"
          />
        </filter>
        <clipPath id={`${id}-a`}>
          <path d="M0 0h375v812H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
